// src/admin/components/StatusBadge.jsx
import React from 'react';
import { COLORS, FONT_SANS, RADII, SEMANTIC } from '../../constants/theme.js';

const PALETTE = {
  completed: { bg: SEMANTIC.verde.bg, fg: SEMANTIC.verde.fg },
  approved:  { bg: SEMANTIC.verde.bg, fg: SEMANTIC.verde.fg },
  failed:    { bg: SEMANTIC.errore.bg,  fg: SEMANTIC.errore.fg },
  drafting:    { bg: SEMANTIC.attenzione.bg, fg: SEMANTIC.attenzione.fg },
  reviewing:   { bg: SEMANTIC.attenzione.bg, fg: SEMANTIC.attenzione.fg },
  correcting:  { bg: SEMANTIC.attenzione.bg, fg: SEMANTIC.attenzione.fg },
  refining:    { bg: SEMANTIC.attenzione.bg, fg: SEMANTIC.attenzione.fg },
  qa_checking: { bg: SEMANTIC.attenzione.bg, fg: SEMANTIC.attenzione.fg },
  reparse:     { bg: SEMANTIC.attenzione.bg, fg: SEMANTIC.attenzione.fg },
  sanitizing:  { bg: SEMANTIC.attenzione.bg, fg: SEMANTIC.attenzione.fg },
  li_format:   { bg: SEMANTIC.attenzione.bg, fg: SEMANTIC.attenzione.fg },
  seo_html:    { bg: SEMANTIC.attenzione.bg, fg: SEMANTIC.attenzione.fg },
};

export default function StatusBadge({ status }) {
  const key = (status || '').toLowerCase();
  const c = PALETTE[key] || { bg: COLORS.border, fg: COLORS.textSecondary };
  return (
    <span style={{
      padding: '2px 8px', borderRadius: RADII.controlInner,
      fontSize: '11px', fontWeight: 600,
      background: c.bg, color: c.fg,
      fontFamily: FONT_SANS,
      textTransform: 'lowercase',
    }}>
      {status || '—'}
    </span>
  );
}
